import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function VideoType(): React.ReactElement {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#video_type)">
        <path d="M18 0.000488281C8.05886 0.000488281 0 8.05935 0 18.0005C0 27.9415 8.05886 36.0004 18 36.0004C27.9411 36.0004 35.9999 27.9415 35.9999 18.0005C35.9894 8.06379 27.9367 0.0111105 18 0.000488281ZM25.5804 18.574C25.4558 18.8239 25.2533 19.0266 25.0032 19.1512V19.1576L14.7176 24.3005C14.0823 24.6179 13.3101 24.3603 12.9927 23.7251C12.9024 23.5445 12.856 23.3451 12.8571 23.1433V12.8576C12.8568 12.1475 13.4321 11.5717 14.1422 11.5713C14.3419 11.5712 14.5389 11.6176 14.7176 11.7069L25.0032 16.8498C25.6388 17.1665 25.8972 17.9384 25.5804 18.574Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="video_type">
          <rect width="36" height="36" fill="white" transform="translate(0 0.000488281)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
